export const webClientId = "123456789-mockclient.apps.googleusercontent.com";
